<template>
  <div class="row">
    <div class="col-12">
      <div class="w-100 d-flex justify-content-end">
        <b-button
          variant="primary"
          @click="modalPostOpen"
        >
          {{$t('modal.nameModalPost')}}
        </b-button>
      </div>
    </div>

    <div class="col-12">
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
        >
          <template #cell(actions)>
            <b-button
              class="me-3"
              variant="success"
              size="sm"
            >
              <i class="bx bx-pencil fs-4"></i>
            </b-button>
            <b-button
              variant="danger"
              size="sm"
            >
              <i class="bx bx-trash fs-4"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DriverTara",
    data() {
      return {
        fields: [
          {key: "id", label: "№"},
          {key: "name", label: this.$t('table.name.label')},
          {key: "actions", label: this.$t('table.actions.label')},
        ],
        modalPostBool: false,
        items: [],
      }
    },
    methods: {
      modalPostOpen() {
        this.modalPostBool = true;
      }
    }
  }
</script>